import {
  CLEAR_RESIDENTES_ACTION,
  FETCH_RESIDENTES,
  SEND_RESIDENT,
  FETCH_RESIDENT_INFO,
  FETCH_VIVIENDAS,
  FETCH_VIVIENDA_INFO,
  CLEAR_VIVIENDAS_ACTION,
  SEND_RESIDENT_APPLICATION,
  SEND_PWD_RESIDENT_APPLICATION,
  CLOSE_SESSION_RESIDENT_APPLICATION,
  DELETE_RESIDENT,
} from './actions.type';

import {
  SUBMITED_RESIDENTE,
  SUBMIT_RESIDENTE_ERROR,
  RESET_RESIDENTE_SUBMIT,
  SET_ERROR,
  CLEAR_RESIDENTES,
  SET_RESIDENTES,
  FETCHED_RESIDENTES,
  FETCHING_RESIDENTES,
  CLEAR_RESIDENT_INFO,
  FETCHING_RESIDENT,
  FETCHED_RESIDENT,
  SET_RESIDENT,
  FETCHING_VIVIENDAS,
  SET_VIVIENDAS,
  FETCHED_VIVIENDAS,
  FETCHING_VIVIENDA,
  CLEAR_VIVIENDA_INFO,
  SET_VIVIENDA,
  FETCHED_VIVIENDA,
  CLEAR_VIVIENDAS,
  CLEAR_ALERT_DIALOG,
  RESET_RESIDENTE_PROCESSING,
  STARTED_RESIDENTE_PROCESSING,
  SUBMITED_RESIDENTE_APPLICATION,
  SUBMIT_APPLICATION_RESIDENTE_ERROR,
  SUBMITED_PWD_RESIDENTE_APPLICATION,
  SUBMIT_PWD_APPLICATION_RESIDENTE_ERROR,
  SUBMITED_CLOSE_SESSION_RESIDENTE_APPLICATION,
  SUBMIT_CLOSE_SESSION_APPLICATION_RESIDENTE_ERROR,
  SUBMITED_RESIDENTE_DELETE,
  CLEAR_ALERT_DIALOG_APP,
  RESET_SUBMITED_RESIDENTE_APPLICATION,
} from './mutations.type';
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  alertDialogApp: true,
  loading_residentes: false,
  submited_residente: false,
  submited_residente_application: false,
  resident_info: {},
  loading_resident: false,
  vivienda_info: {},
  viviendas_list: [],
  processing_residente: false,
};

const getters = {
  is_loading() {
    return state.loading_residentes;
  },
  residentes_list() {
    return state.residentes_list;
  },
  residente_submited() {
    return state.submited_residente;
  },
  resident_info() {
    return state.resident_info;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  alertDialogApp(state) {
    return state.alertDialogApp;
  },
  residente_processing() {
    return state.processing_residente;
  },
  residente_aplicacion_submited() {
    return state.submited_residente_application;
  },
  residentes_total() {
    return state.residentes_total;
  },
};

const actions = {
  [DELETE_RESIDENT](context, residentId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post(`accesos/delete_resident/${residentId}`)
        .then(({ data }) => {
          context.commit(SUBMITED_RESIDENTE_DELETE);
          resolve(data);
          // context.dispatch(FETCH_RESIDENTES);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_RESIDENTE_ERROR, [response.data.message]);
        });
    });
  },
  [CLOSE_SESSION_RESIDENT_APPLICATION](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('usuarios/close_resident_session', data)
        .then(({ data }) => {
          context.commit(SUBMITED_CLOSE_SESSION_RESIDENTE_APPLICATION);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_CLOSE_SESSION_APPLICATION_RESIDENTE_ERROR, [response.data.message]);
        });
    });
  },
  [SEND_PWD_RESIDENT_APPLICATION](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('usuarios/change_resident_pwd', data)
        .then(({ data }) => {
          context.commit(SUBMITED_PWD_RESIDENTE_APPLICATION);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_PWD_APPLICATION_RESIDENTE_ERROR, [response.data.message]);
        });
    });
  },
  [SEND_RESIDENT_APPLICATION](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('usuarios/resident_registration', data)
        .then(({ data }) => {
          context.commit(SUBMITED_RESIDENTE_APPLICATION);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_APPLICATION_RESIDENTE_ERROR, [response.data.message]);
        });
    });
  },
  [SEND_RESIDENT](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.upload('accesos/residentes', data)
        .then(({ data }) => {
          context.commit(SUBMITED_RESIDENTE);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_RESIDENTE_ERROR, [response.data.message]);
        });
    });
  },
  [FETCH_RESIDENTES](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_RESIDENTES);
      ApiService.post('accesos/residentes_list', data)
        .then(({ data }) => {
          context.commit(FETCHED_RESIDENTES);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_RESIDENTES);
        });
    });
  },
  [FETCH_RESIDENT_INFO](context, residentId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_RESIDENT);
      context.commit(CLEAR_RESIDENT_INFO);
      const url = `accesos/residentes/${residentId}`;
      ApiService.query(url)
        .then(({ data }) => {
          context.commit(SET_RESIDENT, data);
          context.commit(FETCHED_RESIDENT);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_RESIDENT);
        });
    });
  },
  [CLEAR_RESIDENTES_ACTION](context) {
    context.commit(CLEAR_RESIDENTES);
  },
  [FETCH_VIVIENDAS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_VIVIENDAS);
      ApiService.query('accesos/viviendas')
        .then(({ data }) => {
          context.commit(SET_VIVIENDAS, data);
          context.commit(FETCHED_VIVIENDAS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_VIVIENDAS);
        });
    });
  },
  [FETCH_VIVIENDA_INFO](context, viviendaId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_VIVIENDA);
      context.commit(CLEAR_VIVIENDA_INFO);
      const url = `accesos/viviendas/${viviendaId}`;
      ApiService.query(url)
        .then(({ data }) => {
          context.commit(SET_VIVIENDA, data);
          context.commit(FETCHED_VIVIENDA);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_VIVIENDA);
        });
    });
  },
  [CLEAR_VIVIENDAS_ACTION](context) {
    context.commit(CLEAR_VIVIENDAS);
  },
};

const mutations = {
  [CLEAR_RESIDENTES](state) {
    state.residentes_list = [];
  },
  [SUBMITED_RESIDENTE](state) {
    state.alert = true;
    state.alertMessage = 'Residente Enviado Correctamente';
    state.alertType = 'success';
    state.submited_residente = true;
  },
  [SUBMIT_RESIDENTE_ERROR](state, data) {
    state.processing_residente = false;
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [RESET_RESIDENTE_SUBMIT](state) {
    state.submited_residente = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [FETCHING_RESIDENTES](state) {
    state.loading_residentes = true;
  },
  [FETCHED_RESIDENTES](state) {
    state.loading_residentes = false;
  },
  [CLEAR_RESIDENT_INFO](state) {
    state.resident_info = {};
  },
  [SET_RESIDENT](state, data) {
    state.alertDialogApp = false;
    state.resident_info = data.residente;
  },
  [FETCHING_RESIDENT](state) {
    state.loading_resident = true;
  },
  [FETCHED_RESIDENT](state) {
    state.loading_resident = false;
  },
  [CLEAR_VIVIENDA_INFO](state) {
    state.vivienda_info = {};
  },
  [SET_VIVIENDA](state, data) {
    state.vivienda_info = data.vivienda;
  },
  [CLEAR_VIVIENDAS](state) {
    state.viviendas_list = [];
  },
  [SET_VIVIENDAS](state, data) {
    state.viviendas_list = data.viviendas;
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alertDialog = false;
    state.alertDialogMessage = '';
    state.alertDialogType = 'success';
  },
  [RESET_RESIDENTE_PROCESSING](state) {
    state.processing_residente = false;
  },
  [STARTED_RESIDENTE_PROCESSING](state) {
    state.processing_residente = true;
  },
  [SUBMITED_RESIDENTE_APPLICATION](state) {
    state.alert = true;
    state.alertMessage = 'Residente Registrado Correctamente';
    state.alertType = 'success';
    state.submited_residente_application = true;
  },
  [SUBMIT_APPLICATION_RESIDENTE_ERROR](state, data) {
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [SUBMITED_PWD_RESIDENTE_APPLICATION](state) {
    state.alert = true;
    state.alertMessage = 'Contraseña del Residente Cambiada Correctamente';
    state.alertType = 'success';
    state.submited_residente_application = true;
  },
  [SUBMIT_PWD_APPLICATION_RESIDENTE_ERROR](state, data) {
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [SUBMITED_CLOSE_SESSION_RESIDENTE_APPLICATION](state) {
    state.alert = true;
    state.alertMessage = 'Sesión Cerrada Correctamente';
    state.alertType = 'success';
    state.submited_residente_application = true;
  },
  [SUBMIT_CLOSE_SESSION_APPLICATION_RESIDENTE_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
    state.submited_residente_application = true;
  },
  [SUBMITED_RESIDENTE_DELETE](state) {
    state.alert = true;
    state.alertMessage = 'Residente Eliminado Correctamente';
    state.alertType = 'success';
    state.submited_residente_application = true;
  },
  [CLEAR_ALERT_DIALOG_APP](state) {
    state.alertDialogApp = true;
  },
  [RESET_SUBMITED_RESIDENTE_APPLICATION](state) {
    state.submited_residente_application = false;
  },
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
